import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=7cf1b9ba&"
import script from "./Page404.vue?vue&type=script&lang=ts&"
export * from "./Page404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports